import { getLocation } from '@/api/api.js'
import { default as langCN } from '@/language/zh-cn.js'
import { default as langZH } from '@/language/zh-hk.js'

const _countryList = [langCN.location.motherCountry, langZH.location.motherCountry]
const _provinceList = [
  langCN.location.hongKong,
  langCN.location.maCao,
  langCN.location.taiWan,
  langZH.location.hongKong,
  langZH.location.maCao,
  langZH.location.taiWan
]

class IpUtil {
  // 返回0，1，2
  // 0: 其他地区
  // 1: 中国大陆
  // 2: 港澳台
  // 接口请求失败返回2
  static async getCurrentArea() {
    let result = 0
    try {
      const { code, data } = await getLocation()
      if (code + '' === '0') {
        const { country, province } = data
        if (_countryList.includes(country) && !_provinceList.includes(province)) {
          result = 1
        }
        if (_countryList.includes(country) && _provinceList.includes(province)) {
          result = 2
        }
      }
    } catch (_) {
      result = 0
    }
    return result
  }

  // 通过IP判断当前使用的语言
  static async getLangFromLocation() {
    let result = 'zh_HK'
    const flag = await this.getCurrentArea()
    // 中国大陆ip才使用简体，其他地区使用繁体
    if (flag === 1) {
      result = 'zh_CN'
    }
    return result
  }
}

export default IpUtil
